<template>
  <div class="manage-content page-card-wrapper">
    <div class="patient-list">
      <div class="page-card-title">
        <span class="page-card-title-text">{{ $t('text.patients') }}</span>
      </div>
      <div class="page-card-content">
        <div class="mt-20">
          <div class="section-title mb-20">
            {{ $t('text.active_patients') }}
            <span class="filter-wrapper">
              <svg-icon
                iconClass="filter"
                className="content-element-color-more-lighter"
              ></svg-icon>
              <el-input
                v-model="activePatientsFilter"
                size="mini"
                class="search-input filter-input"
                :placeholder="$t('text.filter_patients')"
              ></el-input>
            </span>
          </div>
          <div
            class="no-data v-h-center h-200"
            v-if="activePatientsLoading || !activePatientsGroup.length"
            v-loading="activePatientsLoading"
          ></div>
          <el-collapse v-else v-model="activeItems">
            <div
              v-for="(organisation, index) in activePatientsGroup"
              :key="index"
            >
              <el-collapse-item
                v-if="organisation.ActivePatients.length"
                :title="
                  $t('text.organisation') + ': ' + organisation.OrganisationName
                "
                :name="'active' + organisation.OrganisationId"
              >
                <el-table :data="organisation.ActivePatients" border>
                  <el-table-column :label="$t('text.patients')">
                    <template slot-scope="scope">
                      <div>{{ $t('text.name') }}: {{ scope.row.Name }}</div>
                      <div>{{ $t('text.alias') }}: {{ scope.row.Alias }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('text.facility_and_Floor_and_Room')"
                  >
                    <template slot-scope="scope">
                      <div>
                        {{ $t('text.facility') }}: {{ scope.row.BuildingName }}
                      </div>
                      <div>
                        {{ $t('text.floor') }}: {{ scope.row.FloorName }}
                      </div>
                      <div>
                        {{ $t('text.room') }}: {{ scope.row.RoomNumber }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('text.Devices')">
                    <template slot-scope="scope">
                      <div>
                        {{ $t('text.pod_serial_number') }}:
                        {{
                          scope.row.AllocatedPod
                            ? podSerialNumberDisplayPrefix +
                              scope.row.AllocatedPod.substring(
                                scope.row.AllocatedPod.length - 4
                              )
                            : '--'
                        }}
                      </div>
                      <div>
                        {{ $t('text.node_mac_address') }}:
                        {{ scope.row.NodeMacAddress || '--' }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('text.time_period')">
                    <template slot-scope="scope">
                      <div>
                        {{ $t('text.day') }}:
                        {{
                          scope.row.DayProductId
                            ? moment(
                                moment().format('YYYY-MM-DD ') +
                                  scope.row.DayStartTime
                              ).format('h:mm A') +
                              ' - ' +
                              moment(
                                moment().format('YYYY-MM-DD ') +
                                  scope.row.DayEndTime
                              ).format('h:mm A')
                            : '--'
                        }}
                      </div>
                      <div>
                        {{ $t('text.night') }}:
                        {{
                          scope.row.NightProductId
                            ? moment(
                                moment().format('YYYY-MM-DD ') +
                                  scope.row.NightStartTime
                              ).format('h:mm A') +
                              ' - ' +
                              moment(
                                moment().format('YYYY-MM-DD ') +
                                  scope.row.NightEndTime
                              ).format('h:mm A')
                            : '--'
                        }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('text.products')">
                    <template slot-scope="scope">
                      <div>
                        {{ $t('text.day') }}:
                        {{
                          scope.row.DayProductId
                            ? scope.row.DayProductName
                            : '--'
                        }}
                      </div>
                      <div>
                        {{ $t('text.night') }}:
                        {{
                          scope.row.NightProductId
                            ? scope.row.NightProductName
                            : '--'
                        }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('text.action')"
                    v-if="
                      p('Manage Module.Patients.Patients Module.Edit') ||
                        p('Manage Module.Patients.Patients Module.Delete') ||
                        p('Manage Module.Patients.Patients Module.Archive')
                    "
                  >
                    <template slot-scope="scope">
                      <div
                        class="blue-font underline pointer inline-block mr-10"
                        @click="editPatient(scope.row)"
                        v-if="p('Manage Module.Patients.Patients Module.Edit')"
                      >
                        {{ $t('text.edit') | firstLetterCapitalize }}
                      </div>
                      <div
                        class="blue-font underline pointer inline-block mr-10"
                        @click="doArchivePatient(scope.row)"
                        v-if="
                          p('Manage Module.Patients.Patients Module.Archive')
                        "
                      >
                        {{ $t('text.archive') | firstLetterCapitalize }}
                      </div>
                      <div
                        class="red-font underline pointer inline-block"
                        @click="deletePatient(scope.row)"
                        v-if="
                          p('Manage Module.Patients.Patients Module.Delete')
                        "
                      >
                        {{ $t('text.delete') | firstLetterCapitalize }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </div>
          </el-collapse>
          <div class="text-right mt-30">
            <el-button
              type="success"
              plain
              class="common-btn"
              @click="addPatient()"
              v-if="p('Manage Module.Patients.Patients Module.Add')"
              >{{ $t('text.add_patient').toUpperCase() }}</el-button
            >
          </div>
          <div class="section-title mt-20 mb-20">
            {{ $t('text.archived_patients') }}
            <span class="filter-wrapper">
              <svg-icon
                iconClass="filter"
                className="content-element-color-more-lighter"
              ></svg-icon>
              <el-input
                v-model="archivedPatientsFilter"
                size="mini"
                class="search-input filter-input"
                :placeholder="$t('text.filter_patients')"
              ></el-input>
            </span>
          </div>
          <div
            class="no-data v-h-center h-200"
            v-if="archivePatientsLoading || !archivePatientsGroup.length"
            v-loading="archivePatientsLoading"
          ></div>
          <el-collapse v-else v-model="archiveItems">
            <div
              v-for="(organisation, index) in archivePatientsGroup"
              :key="index"
            >
              <el-collapse-item
                v-if="organisation.ArchivePatients.length"
                :title="
                  $t('text.organisation') + ': ' + organisation.OrganisationName
                "
                :name="'archive' + organisation.OrganisationId"
              >
                <el-table :data="organisation.ArchivePatients" border>
                  <el-table-column :label="$t('text.patients')">
                    <template slot-scope="scope">
                      <div>{{ $t('text.name') }}: {{ scope.row.Name }}</div>
                      <div>{{ $t('text.alias') }}: {{ scope.row.Alias }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('text.facility_and_Floor_and_Room')"
                  >
                    <template slot-scope="scope">
                      <div>
                        {{ $t('text.facility') }}: {{ scope.row.BuildingName }}
                      </div>
                      <div>
                        {{ $t('text.floor') }}: {{ scope.row.FloorName }}
                      </div>
                      <div>
                        {{ $t('text.room') }}: {{ scope.row.RoomNumber }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('text.Devices')">
                    <template slot-scope="scope">
                      <div>
                        {{ $t('text.pod_serial_number') }}:
                        {{
                          scope.row.AllocatedPod
                            ? podSerialNumberDisplayPrefix +
                              scope.row.AllocatedPod.substring(
                                scope.row.AllocatedPod.length - 4
                              )
                            : '--'
                        }}
                      </div>
                      <div>
                        {{ $t('text.node_mac_address') }}:
                        {{ scope.row.NodeMacAddress || '--' }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('text.time_period')">
                    <template slot-scope="scope">
                      <div>
                        {{ $t('text.day') }}:
                        {{
                          scope.row.DayProductId
                            ? moment(
                                moment().format('YYYY-MM-DD ') +
                                  scope.row.DayStartTime
                              ).format('h:mm A') +
                              ' - ' +
                              moment(
                                moment().format('YYYY-MM-DD ') +
                                  scope.row.DayEndTime
                              ).format('h:mm A')
                            : '--'
                        }}
                      </div>
                      <div>
                        {{ $t('text.night') }}:
                        {{
                          scope.row.NightProductId
                            ? moment(
                                moment().format('YYYY-MM-DD ') +
                                  scope.row.NightStartTime
                              ).format('h:mm A') +
                              ' - ' +
                              moment(
                                moment().format('YYYY-MM-DD ') +
                                  scope.row.NightEndTime
                              ).format('h:mm A')
                            : '--'
                        }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('text.products')">
                    <template slot-scope="scope">
                      <div>
                        {{ $t('text.day') }}:
                        {{
                          scope.row.DayProductId
                            ? scope.row.DayProductName
                            : '--'
                        }}
                      </div>
                      <div>
                        {{ $t('text.night') }}:
                        {{
                          scope.row.NightProductId
                            ? scope.row.NightProductName
                            : '--'
                        }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('text.action')"
                    v-if="p('Manage Module.Patients.Patients Module.Restore')"
                  >
                    <template slot-scope="scope">
                      <div
                        class="blue-font underline pointer inline-block mr-10"
                        @click="restorePatient(scope.row)"
                      >
                        {{ $t('text.restore') | firstLetterCapitalize }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </div>
          </el-collapse>
        </div>
      </div>
      <EditPatient
        ref="editPatient"
        :shouldRedirectDashboard="false"
        @saveSuccess="getData('active')"
      />
    </div>
  </div>
</template>

<script>
import EditPatient from '@/components/manage/patients/EditPatient.vue'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import moment from 'moment'
import { podSerialNumberDisplayPrefix, filterFlag } from '@/const'
export default {
  data() {
    return {
      podSerialNumberDisplayPrefix,
      moment,
      activePatientsFilter: '',
      archivedPatientsFilter: '',
      activePatientsGroup: [], //Active Patients data
      archivePatientsGroup: [], //archive patients data
      activePatientsLoading: false,
      archivePatientsLoading: false,
      timer: '',
      user: JSON.parse(localStorage.getItem('user')),
      activeItems: [],
      archiveItems: []
    }
  },
  components: {
    EditPatient
  },
  mounted() {
    this.getData('all')
  },
  watch: {
    activePatientsFilter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.getData('active'), 500)
    },
    archivedPatientsFilter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.getData('archive'), 500)
    }
  },
  methods: {
    calcLoading(type, loading) {
      // Calculate which module needs loading
      if (type === 'all') {
        this.activePatientsLoading = this.archivePatientsLoading = loading
      } else if (type === 'active') {
        this.activePatientsLoading = loading
      } else {
        this.archivePatientsLoading = loading
      }
    },
    getData(type) {
      this.calcLoading(type, true)
      ApiService.GetAllPatientsV3(
        this.$store.getters[`filter/calculatedFilter`].organisationId,
        filterFlag.all,
        []
      )
        .then(response => {
          this.calcLoading(type, false)
          if (response.data.success) {
            let patients = response.data.data
            if (!patients.length) return false
            // Calculate active patients module and archived patients module data
            this.activePatientsGroup = patients.filter(item => {
              return item.ActivePatients.length
            })
            this.archivePatientsGroup = patients.filter(item => {
              return item.ArchivePatients.length
            })

            // Expand the first folded panel by default
            if (!this.activeItems.length && this.activePatientsGroup.length) {
              this.activeItems =
                'active' + this.activePatientsGroup[0].OrganisationId
            }
            if (!this.archiveItems.length && this.archivePatientsGroup.length) {
              this.archiveItems =
                'archive' + this.archivePatientsGroup[0].OrganisationId
            }

            // Calculate filtered data
            if (this.activePatientsFilter) {
              this.activePatientsGroup = this.activePatientsGroup.map(
                organisation => {
                  return {
                    ...organisation,
                    ActivePatients: organisation.ActivePatients.filter(item => {
                      return (
                        item.Alias.toLowerCase().indexOf(
                          this.activePatientsFilter.toLowerCase()
                        ) > -1 ||
                        item.Name.toLowerCase().indexOf(
                          this.activePatientsFilter.toLowerCase()
                        ) > -1
                      )
                    })
                  }
                }
              )
            }

            if (this.archivedPatientsFilter) {
              this.archivePatientsGroup = this.archivePatientsGroup.map(
                organisation => {
                  return {
                    ...organisation,
                    ArchivePatients: organisation.ArchivePatients.filter(
                      item => {
                        return (
                          item.Alias.toLowerCase().indexOf(
                            this.archivedPatientsFilter.toLowerCase()
                          ) > -1 ||
                          item.Name.toLowerCase().indexOf(
                            this.archivedPatientsFilter.toLowerCase()
                          ) > -1
                        )
                      }
                    )
                  }
                }
              )
            }
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.calcLoading(type, false)
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    addPatient() {
      this.$refs.editPatient.openDialog()
    },
    deletePatient(item) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.delete_patient_warning'
        )}</div>` + `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.you_able_to_delete_data') + ' ' + item.Alias,
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleDelete(item)
        })
        .catch(() => {})
    },
    handleDelete(item) {
      this.calcLoading('active', true)
      ApiService.DeleteMemberShipPatient(item.PatientId).then(response => {
        this.calcLoading('active', false)
        if (response.data.success) {
          this.getData('active')
          this.$store.dispatch('patient/fetchPatients')
        } else {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    editPatient(item) {
      this.$refs.editPatient.openDialog()
      let obj = JSON.parse(JSON.stringify(item))
      obj = {
        ...item,
        DayManufacturerId: item.DayManufacturerId || '',
        DayProductId: item.DayProductId || '',
        NightProductId: item.NightProductId || '',
        NightManufacturerId: item.NightManufacturerId || '',
        DayStartTime: item.DayProductId ? item.DayStartTime : '',
        DayEndTime: item.DayProductId ? item.DayEndTime : '',
        NightStartTime: item.NightProductId ? item.NightStartTime : '',
        NightEndTime: item.NightProductId ? item.NightEndTime : '',
        AllocatedPod: item.AllocatedPod.substring(item.AllocatedPod.length - 4)
      }
      this.$nextTick(() => {
        this.$refs.editPatient.isEdit = true
        this.$refs.editPatient.$refs.patientDetailSection.form = obj
        this.$refs.editPatient.$refs.patientBuildingSection.form = obj
        this.$refs.editPatient.$refs.patientDeviceSection.form = obj
        this.$refs.editPatient.$refs.patientProductsSection.form = obj
      })
    },
    doArchivePatient(item) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.confirm_archive'
        )}</div>` + `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.you_about_to_archive') + ' ' + item.Alias,
        {
          confirmButtonText: this.$t('text.yes').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        this.handleArchive(item)
      })
    },
    handleArchive(item) {
      this.calcLoading('all', true)
      ApiService.ArchivePatient(item.PatientId).then(response => {
        this.calcLoading('all', false)
        if (response.data.success) {
          this.getData('all')
          this.$store.dispatch('patient/fetchPatients')
        } else {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    restorePatient(item) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.restore_patient'
        )}.</div>` + `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.restoring_patient') + ' ' + item.Alias,
        {
          confirmButtonText: this.$t('text.yes').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        this.handleRestorePatient(item)
      })
    },
    handleRestorePatient(item) {
      this.calcLoading('all', true)
      ApiService.UnArchivePatient(item.PatientId).then(response => {
        this.calcLoading('all', false)
        if (response.data.success) {
          this.getData('all')
          this.$store.dispatch('patient/fetchPatients')
        } else {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
